export const GEN1_PIPELINE_FLAG = 'SLPL-1350-gen1-pipeline-for-gen4'

export function isGen1SlideBucket(bucket, slideId) {
  if (typeof bucket !== 'string') return false
  const prefix = `slide-${slideId}-`
  if (!bucket.startsWith(prefix)) return false
  return /^\d+(\/|$)/.test(bucket.slice(prefix.length))
}

export function gen1SlideTypeOf(component) {
  const slideConfig = component.slideForPlugin
    ? component.slideConfigByType?.(component.slideForRender?.type)
    : component.slideActiveConfig
  return slideConfig?.gen1SlideType
}
